var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === _vm.PRODUCT_LABEL_TYPES.badge)?_c('ProductBadgeLabelCreateForm',{attrs:{"type":_vm.type}}):_c('ProductLabelCreateForm',{attrs:{"type":_vm.type}})}
var staticRenderFns = []

export { render, staticRenderFns }